export default [
  // {
  //   title: '考前密卷',
  //   name: 'content'
  // }
  {
    title: '开始题目',
    name: 'accItem'
  },
  {
    title: '2018年执业药师考试真题',
    name: 'accEntry'
  },
  {
    title: '鸭题库药考查分助手',
    name: 'queryScore'
  }
]


// WEBPACK FOOTER //
// ./src/route/accountingRouter.js